import React, {useContext, useEffect} from 'react'
import {
  shouldRenderComponentWhenLegalRepAndNotSignatory,
  COMPANY_LEGAL_REPRESENTATIVES,
} from '@modifi/plugin-onboarding'
import {FormDataContext} from '@modifi/plugin-forms'

type SignatoryFieldWatcherProps = {
  onVisibilityChange: (shouldRender: boolean) => void
}

// the signatory filter reads live form data, only reachable inside <Form>
const SignatoryFieldWatcher: React.FC<SignatoryFieldWatcherProps> = ({onVisibilityChange}) => {
  const {data} = useContext(FormDataContext)
  const shouldRender = shouldRenderComponentWhenLegalRepAndNotSignatory(data, {
    formType: COMPANY_LEGAL_REPRESENTATIVES,
  })

  useEffect(() => {
    onVisibilityChange(shouldRender)
  }, [onVisibilityChange, shouldRender])

  return null
}

export default SignatoryFieldWatcher
